module.exports = __webpack_public_path__ + "img/02.753b1ee8.png";